import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {BtnPrimary} from "../../../../../components/BtnPrimary";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AdultosOnboarding = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-adultos-mobile${currentParams}`);
  };

  const handleButtonClickOnboarding = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_tutorial_easy-adultos-mobile${currentParams}`);
  };

  return (
      <div className="adultos-onboarding">
        <div className="div-7">
          <div className="overlap-group-11">
            <svg
                width={490}
                height={239}
                viewBox="0 0 375 239"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M87.2391 280.362L278.969 66.1216L292.29 51.9809L292.38 52.0768L86.9893 281.59C87.0661 281.181 87.1559 280.778 87.2391 280.368"
                  fill="url(#paint0_linear_2630_5042)"
              />
              <path
                  d="M87.9307 297.29L299.799 59.6228L300.427 60.256L88.2254 298.301C88.1229 297.962 88.0268 297.629 87.9307 297.29Z"
                  fill="url(#paint1_linear_2630_5042)"
              />
              <path
                  d="M93.1402 309.277L308.308 68.2897L309.115 69.1148L93.7617 310.3C93.5439 309.961 93.3388 309.622 93.1338 309.277"
                  fill="url(#paint2_linear_2630_5042)"
              />
              <path
                  d="M100.47 318.876L316.823 76.9556L317.816 77.9661L101.45 319.899C101.117 319.56 100.796 319.215 100.47 318.876Z"
                  fill="url(#paint3_linear_2630_5042)"
              />
              <path
                  d="M108.838 327.311L325.338 85.6275L326.511 86.8235L110.023 328.501L108.838 327.311Z"
                  fill="url(#paint4_linear_2630_5042)"
              />
              <path
                  d="M117.225 335.729L333.847 94.2946L335.205 95.6824L118.596 337.098L117.225 335.729Z"
                  fill="url(#paint5_linear_2630_5042)"
              />
              <path
                  d="M125.612 344.139L342.363 102.966L343.9 104.533L127.169 345.699L125.612 344.139Z"
                  fill="url(#paint6_linear_2630_5042)"
              />
              <path
                  d="M133.999 352.549L350.871 111.633L352.601 113.391L135.735 354.295L133.999 352.549Z"
                  fill="url(#paint7_linear_2630_5042)"
              />
              <path
                  d="M142.386 360.959L359.386 120.299L361.295 122.243L144.314 362.891L142.386 360.959Z"
                  fill="url(#paint8_linear_2630_5042)"
              />
              <path
                  d="M150.767 369.369L367.895 128.965L369.99 131.101L152.881 371.486L150.767 369.369Z"
                  fill="url(#paint9_linear_2630_5042)"
              />
              <path
                  d="M159.154 377.773L376.411 137.631L378.685 139.952L161.448 380.082L159.154 377.773Z"
                  fill="url(#paint10_linear_2630_5042)"
              />
              <path
                  d="M167.541 386.184L384.919 146.297L387.38 148.811L170.021 388.672L167.541 386.184Z"
                  fill="url(#paint11_linear_2630_5042)"
              />
              <path
                  d="M175.922 394.594L393.428 154.97L396.074 157.662L178.587 397.268L175.922 394.594Z"
                  fill="url(#paint12_linear_2630_5042)"
              />
              <path
                  d="M184.303 402.997L401.937 163.628L404.769 166.512L187.154 405.855L184.303 402.997Z"
                  fill="url(#paint13_linear_2630_5042)"
              />
              <path
                  d="M192.683 411.401L410.445 172.295L413.463 175.364L195.72 414.445L192.683 411.401Z"
                  fill="url(#paint14_linear_2630_5042)"
              />
              <path
                  d="M201.063 419.805L418.954 180.961L422.152 184.216L204.286 423.041L201.063 419.805Z"
                  fill="url(#paint15_linear_2630_5042)"
              />
              <path
                  d="M209.444 428.21L427.463 189.628L430.846 193.075L212.853 431.625L209.444 428.21Z"
                  fill="url(#paint16_linear_2630_5042)"
              />
              <path
                  d="M217.818 436.612L435.972 198.292L439.541 201.919L221.413 440.213L217.818 436.612Z"
                  fill="url(#paint17_linear_2630_5042)"
              />
              <path
                  d="M226.199 445.017L444.481 206.959L448.236 210.777L229.973 448.803L226.199 445.017Z"
                  fill="url(#paint18_linear_2630_5042)"
              />
              <path
                  d="M234.58 453.415L452.99 215.619L456.924 219.629L238.54 457.393L234.58 453.415Z"
                  fill="url(#paint19_linear_2630_5042)"
              />
              <path
                  d="M242.954 461.817L461.499 224.284L465.612 228.473L247.1 465.975L242.954 461.817Z"
                  fill="url(#paint20_linear_2630_5042)"
              />
              <path
                  d="M251.328 470.216L470.007 232.945L474.306 237.326L255.659 474.559L251.328 470.216Z"
                  fill="url(#paint21_linear_2630_5042)"
              />
              <path
                  d="M-184.915 280.471C-184.966 279.313 -184.986 278.162 -185.018 277.011L-3.34044 69.5178C-0.662216 69.2236 2.02881 68.9741 4.73907 68.7887L-184.659 285.095C-184.761 283.553 -184.851 282.012 -184.915 280.464"
                  fill="url(#paint22_linear_2630_5042)"
              />
              <path
                  d="M-183.974 293.095L12.9271 68.4109C15.3683 68.3405 17.803 68.3022 20.225 68.315L-183.096 300.322C-183.435 297.924 -183.724 295.513 -183.974 293.089"
                  fill="url(#paint23_linear_2630_5042)"
              />
              <path
                  d="M-181.872 307.953L28.1315 68.5201C30.3484 68.616 32.5589 68.7503 34.763 68.9166L-180.597 314.457C-181.058 312.302 -181.481 310.134 -181.872 307.953Z"
                  fill="url(#paint24_linear_2630_5042)"
              />
              <path
                  d="M-178.893 321.8L42.4518 69.6589C44.4765 69.8892 46.5011 70.1578 48.5066 70.452L-177.304 327.684C-177.861 325.733 -178.393 323.776 -178.893 321.8Z"
                  fill="url(#paint25_linear_2630_5042)"
              />
              <path
                  d="M-175.15 334.764L56.0034 71.6799C57.8615 72.0253 59.7196 72.3898 61.5585 72.78L-173.331 340.123C-173.965 338.351 -174.567 336.561 -175.15 334.764Z"
                  fill="url(#paint26_linear_2630_5042)"
              />
              <path
                  d="M-170.749 346.959L68.8687 74.4931C70.5795 74.9216 72.2774 75.3757 73.9689 75.849L-168.737 351.826C-169.429 350.214 -170.095 348.596 -170.749 346.959Z"
                  fill="url(#paint27_linear_2630_5042)"
              />
              <path
                  d="M-165.758 358.478L81.145 77.9983C82.7148 78.5036 84.2781 79.0216 85.8287 79.5589L-163.599 362.91C-164.335 361.439 -165.059 359.962 -165.758 358.478Z"
                  fill="url(#paint28_linear_2630_5042)"
              />
              <path
                  d="M-160.209 369.351L92.8512 82.1555C94.2928 82.7183 95.728 83.2939 97.1568 83.8887L-157.934 373.393C-158.71 372.056 -159.466 370.706 -160.209 369.351Z"
                  fill="url(#paint29_linear_2630_5042)"
              />
              <path
                  d="M-154.173 379.655L104.052 86.8953C105.378 87.5028 106.691 88.1296 108.005 88.7692L-151.809 383.332C-152.609 382.117 -153.398 380.889 -154.173 379.655Z"
                  fill="url(#paint30_linear_2630_5042)"
              />
              <path
                  d="M-147.657 389.413L114.752 92.2216C115.969 92.8675 117.18 93.5262 118.378 94.1978L-145.241 392.758C-146.061 391.651 -146.862 390.532 -147.663 389.413"
                  fill="url(#paint31_linear_2630_5042)"
              />
              <path
                  d="M-140.692 398.642L124.996 98.0612C126.105 98.7391 127.207 99.4363 128.309 100.133L-138.226 401.674C-139.052 400.67 -139.879 399.666 -140.692 398.642Z"
                  fill="url(#paint32_linear_2630_5042)"
              />
              <path
                  d="M-133.298 407.393L134.787 104.432C135.806 105.129 136.818 105.833 137.824 106.556L-130.806 410.117C-131.645 409.215 -132.478 408.307 -133.305 407.393"
                  fill="url(#paint33_linear_2630_5042)"
              />
              <path
                  d="M-125.481 415.649L144.135 111.301C145.058 112.024 145.974 112.746 146.884 113.482L-122.983 418.111C-123.822 417.299 -124.655 416.474 -125.481 415.649Z"
                  fill="url(#paint34_linear_2630_5042)"
              />
              <path
                  d="M-117.248 423.425L153.067 118.648C153.906 119.377 154.726 120.126 155.546 120.868L-114.749 425.625C-115.589 424.896 -116.422 424.16 -117.248 423.419"
                  fill="url(#paint35_linear_2630_5042)"
              />
              <path
                  d="M-108.611 430.743L161.543 126.51C162.299 127.245 163.055 127.981 163.799 128.729L-106.119 432.693C-106.952 432.047 -107.785 431.401 -108.605 430.743"
                  fill="url(#paint36_linear_2630_5042)"
              />
              <path
                  d="M-99.5512 437.578L169.61 134.842C170.283 135.578 170.949 136.326 171.616 137.074L-97.0972 439.299C-97.9174 438.73 -98.7375 438.16 -99.5576 437.578"
                  fill="url(#paint37_linear_2630_5042)"
              />
              <path
                  d="M-90.0752 443.935L177.222 143.68C177.818 144.416 178.407 145.158 178.997 145.906L-87.6597 445.451C-88.4734 444.952 -89.2679 444.441 -90.0752 443.935Z"
                  fill="url(#paint38_linear_2630_5042)"
              />
              <path
                  d="M-80.8809 449.418L183.905 152.374C184.43 153.096 184.962 153.825 185.481 154.555L-78.5166 450.723C-79.3111 450.294 -80.0928 449.859 -80.8744 449.418"
                  fill="url(#paint39_linear_2630_5042)"
              />
              <path
                  d="M-70.0146 455.091L190.965 162.716C191.426 163.439 191.868 164.161 192.323 164.89L-67.6952 456.191C-68.4705 455.827 -69.2458 455.462 -70.0082 455.091"
                  fill="url(#paint40_linear_2630_5042)"
              />
              <path
                  d="M-58.7954 460.097L197.379 173.51C197.77 174.22 198.16 174.917 198.545 175.633L-56.5528 461.012C-57.3089 460.711 -58.0521 460.404 -58.8018 460.097"
                  fill="url(#paint41_linear_2630_5042)"
              />
              <path
                  d="M-47.1274 464.492L203.21 184.838C203.536 185.528 203.85 186.232 204.171 186.929L-44.9489 465.215C-45.6794 464.978 -46.4098 464.735 -47.1338 464.492"
                  fill="url(#paint42_linear_2630_5042)"
              />
              <path
                  d="M-33.2754 468.68L209.04 198.401C209.303 199.079 209.546 199.764 209.802 200.448L-31.161 469.211C-31.8658 469.032 -32.577 468.859 -33.2754 468.68Z"
                  fill="url(#paint43_linear_2630_5042)"
              />
              <path
                  d="M-20.6846 471.559L213.391 210.873C213.59 211.526 213.807 212.172 214.006 212.824L-18.6727 471.955C-19.3455 471.827 -20.0118 471.686 -20.6846 471.559Z"
                  fill="url(#paint44_linear_2630_5042)"
              />
              <path
                  d="M-7.43457 473.709L217.056 224.107C217.21 224.734 217.357 225.354 217.498 225.987L-5.5124 473.945C-6.15312 473.869 -6.79385 473.792 -7.43457 473.709Z"
                  fill="url(#paint45_linear_2630_5042)"
              />
              <path
                  d="M7.16699 475.057L220.022 238.784C220.124 239.385 220.214 239.98 220.304 240.581L8.98664 475.141C8.37796 475.115 7.76927 475.089 7.16699 475.057Z"
                  fill="url(#paint46_linear_2630_5042)"
              />
              <defs>
                <linearGradient
                    id="paint0_linear_2630_5042"
                    x1={94.238}
                    y1={145.72}
                    x2={299.628}
                    y2={145.72}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2630_5042"
                    x1={95.4302}
                    y1={157.065}
                    x2={307.926}
                    y2={157.065}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2630_5042"
                    x1={100.756}
                    y1={167.092}
                    x2={316.738}
                    y2={167.092}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2630_5042"
                    x1={108.14}
                    y1={176.139}
                    x2={325.487}
                    y2={176.139}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_2630_5042"
                    x1={116.52}
                    y1={184.782}
                    x2={334.193}
                    y2={184.782}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_2630_5042"
                    x1={124.918}
                    y1={193.421}
                    x2={342.898}
                    y2={193.421}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_2630_5042"
                    x1={133.316}
                    y1={202.064}
                    x2={351.604}
                    y2={202.064}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_2630_5042"
                    x1={141.714}
                    y1={210.701}
                    x2={360.316}
                    y2={210.701}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_2630_5042"
                    x1={150.112}
                    y1={219.338}
                    x2={369.021}
                    y2={219.338}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_2630_5042"
                    x1={158.504}
                    y1={227.976}
                    x2={377.727}
                    y2={227.976}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_2630_5042"
                    x1={166.902}
                    y1={236.613}
                    x2={386.433}
                    y2={236.613}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_2630_5042"
                    x1={175.3}
                    y1={245.248}
                    x2={395.138}
                    y2={245.248}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_2630_5042"
                    x1={183.692}
                    y1={253.89}
                    x2={403.844}
                    y2={253.89}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_2630_5042"
                    x1={192.084}
                    y1={262.519}
                    x2={412.55}
                    y2={262.519}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_2630_5042"
                    x1={200.475}
                    y1={271.154}
                    x2={421.255}
                    y2={271.154}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_2630_5042"
                    x1={208.866}
                    y1={279.792}
                    x2={429.954}
                    y2={279.792}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_2630_5042"
                    x1={217.258}
                    y1={288.425}
                    x2={438.66}
                    y2={288.425}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint17_linear_2630_5042"
                    x1={225.644}
                    y1={297.058}
                    x2={447.366}
                    y2={297.058}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_2630_5042"
                    x1={234.035}
                    y1={305.693}
                    x2={456.072}
                    y2={305.693}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_2630_5042"
                    x1={242.427}
                    y1={314.325}
                    x2={464.771}
                    y2={314.325}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_2630_5042"
                    x1={250.812}
                    y1={322.956}
                    x2={473.47}
                    y2={322.956}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_2630_5042"
                    x1={259.198}
                    y1={331.585}
                    x2={482.176}
                    y2={331.585}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.septimo} />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_2630_5042"
                    x1={-182.222}
                    y1={165.89}
                    x2={7.53462}
                    y2={165.89}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint23_linear_2630_5042"
                    x1={-180.965}
                    y1={172.463}
                    x2={23.2333}
                    y2={172.463}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_2630_5042"
                    x1={-178.681}
                    y1={178.923}
                    x2={37.9545}
                    y2={178.923}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint25_linear_2630_5042"
                    x1={-175.542}
                    y1={185.488}
                    x2={51.8567}
                    y2={185.488}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint26_linear_2630_5042"
                    x1={-171.663}
                    y1={192.186}
                    x2={65.0457}
                    y2={192.186}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint27_linear_2630_5042"
                    x1={-167.144}
                    y1={198.99}
                    x2={77.5742}
                    y2={198.99}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint28_linear_2630_5042"
                    x1={-162.051}
                    y1={205.897}
                    x2={89.5351}
                    y2={205.897}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint29_linear_2630_5042"
                    x1={-156.417}
                    y1={212.894}
                    x2={100.948}
                    y2={212.894}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint30_linear_2630_5042"
                    x1={-150.31}
                    y1={219.968}
                    x2={111.867}
                    y2={219.968}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint31_linear_2630_5042"
                    x1={-143.744}
                    y1={227.134}
                    x2={122.298}
                    y2={227.134}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint32_linear_2630_5042"
                    x1={-136.729}
                    y1={234.355}
                    x2={132.272}
                    y2={234.355}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint33_linear_2630_5042"
                    x1={-129.31}
                    y1={241.656}
                    x2={141.818}
                    y2={241.656}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint34_linear_2630_5042"
                    x1={-121.469}
                    y1={249.03}
                    x2={150.896}
                    y2={249.03}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint35_linear_2630_5042"
                    x1={-113.229}
                    y1={256.452}
                    x2={159.565}
                    y2={256.452}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint36_linear_2630_5042"
                    x1={-104.598}
                    y1={263.958}
                    x2={167.812}
                    y2={263.958}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint37_linear_2630_5042"
                    x1={-95.5626}
                    y1={271.515}
                    x2={175.611}
                    y2={271.515}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint38_linear_2630_5042"
                    x1={-86.1112}
                    y1={279.147}
                    x2={182.961}
                    y2={279.147}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint39_linear_2630_5042"
                    x1={-76.9567}
                    y1={286.304}
                    x2={189.405}
                    y2={286.304}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint40_linear_2630_5042"
                    x1={-66.1498}
                    y1={294.459}
                    x2={196.188}
                    y2={294.459}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint41_linear_2630_5042"
                    x1={-55.0105}
                    y1={302.571}
                    x2={202.336}
                    y2={302.571}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint42_linear_2630_5042"
                    x1={-43.4315}
                    y1={310.701}
                    x2={207.873}
                    y2={310.701}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint43_linear_2630_5042"
                    x1={-29.6943}
                    y1={319.97}
                    x2={213.383}
                    y2={319.97}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint44_linear_2630_5042"
                    x1={-17.227}
                    y1={328.075}
                    x2={217.464}
                    y2={328.075}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint45_linear_2630_5042"
                    x1={-4.1208}
                    y1={336.261}
                    x2={220.812}
                    y2={336.261}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
                <linearGradient
                    id="paint46_linear_2630_5042"
                    x1={10.307}
                    y1={344.886}
                    x2={223.444}
                    y2={344.886}
                    gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor={colors.secundario} />
                  <stop offset={0.26} stopColor={colors.secundario} />
                  <stop offset={0.36} stopColor={colors.secundario} />
                  <stop offset={0.49} stopColor={colors.secundario} />
                  <stop offset={0.63} stopColor={colors.secundario} />
                  <stop offset={0.79} stopColor={colors.secundario} />
                  <stop offset={0.85} stopColor={colors.secundario} />
                  <stop offset={1} stopColor={colors.secundario} />
                </linearGradient>
              </defs>
            </svg>

            <img className="capa-2" alt="Capa" src="/img/capa-1-1.svg" />
          </div>

          <div className="overlap-5">
            {/* <div className="navs-statusbar-2">
            <div className="content-4">
              <div className="text-wrapper-31">9:50</div>

              <img className="icons-3" alt="Icons" src="/img/icons.svg" />
            </div>
          </div> */}

            <img
                className="rectangle-9"
                alt="Rectangle"
                src="/img/rectangle.png"
            />
          </div>

          <div className="buttons-2">
            {colors.url_logo !== "" && (
                <img width={100} height="auto" src={colors.url_logo} />
            )}

            <div>
              <p className="text-wrapper-30">Welcome</p>
              <p className="text-wrapper-30">It’s nice to see u!</p>
            </div>
            <div onClick={handleButtonClick} style={{ width: "100%" }}>
              <BtnPrimary
                  className="btn-primary-5 highlighted-button"
                  divClassName="btn-primary-6"
                  text="Login by Password"
                  center={true}
              />
            </div>
            <div
                className="highlighted-button"
                style={{ width: "100%" }}
                onClick={handleButtonClickOnboarding}
            >
              <BtnPrimary
                  className="btn-primary-7"
                  divClassName="btn-primary-8"
                  text="Sign in"
              />
            </div>
          </div>
        </div>
      </div>
  );
};
